import { render, staticRenderFns } from "./TransLegalDialog.vue?vue&type=template&id=4533842e&"
import script from "./TransLegalDialog.vue?vue&type=script&lang=js&"
export * from "./TransLegalDialog.vue?vue&type=script&lang=js&"
import style0 from "./TransLegalDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports